import { forwardRef, FC, RefAttributes, ForwardRefExoticComponent } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

type Elements = {
  Left: FC<BoxProps>;
  Right: FC<BoxProps>;
};

export const FlexRow = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return (
    <Box
      display="flex"
      flexDir="row"
      justifyContent="space-between"
      alignItems="center"
      ref={ref}
      {...props}
    />
  );
}) as ForwardRefExoticComponent<BoxProps & RefAttributes<HTMLDivElement>> & Elements;

FlexRow.Left = function FlexRowLeft(props) {
  return (
    <Box
      display="flex"
      flexDir="row"
      justifyContent="left"
      alignItems="center"
      {...props}
    />
  );
};

FlexRow.Right = function FlexRowRight(props) {
  return (
    <Box
      display="flex"
      flexDir="row"
      justifyContent="right"
      alignItems="center"
      {...props}
    />
  );
};
